import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const SchoolHat = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z"
      clipRule="evenodd"
    />
  </svg>,
  'SchoolHat'
);

export default SchoolHat;


